  <template>
  <v-form
    ref="form"
    v-model="formValid"
    lazy-validation
  >
    <v-card>
      <v-container
        class="pa-5"
      >
        <v-layout align-center class="mb-5">
          <v-flex>
            <v-avatar
              size="150"
              class="mr-3"
              @click="pickFile"
              :style="{ cursor: 'pointer' }"
            >
              <img ref="photo" :src="user.image_url" alt="avatar" />
            </v-avatar>
            <v-btn
              @click="pickFile"
              flat
            >
              <v-icon color="accent">photo_camera</v-icon>
              <strong class="accent--text">Change Photo</strong>
            </v-btn>
            <input
              type="file"
              accept="image/*"
              ref="inputFile"
              @change="onFilePicked"
              :style="{ display: 'none' }"
            />
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12>
            <strong class="mb-3">Basic Details</strong>
            <v-subheader><em>* Use name appeared in PRC ID</em></v-subheader>
          </v-flex>
          
          <v-flex md4>
            <v-text-field
              label="Last Name"
              v-model="lastName"
              :rules="lastNameRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="First Name"
              v-model="firstName"
              :rules="firstNameRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Middle Name"
              v-model="middleName"
            ></v-text-field>
          </v-flex>
          <!--<v-flex md4>
            <v-text-field
              type="date"
              label="Birthday"
              v-model="birthday"
              required
            ></v-text-field>
          </v-flex>-->
          <!--<v-flex md4>
            <v-text-field
              label="Primary Contact Number"
              v-model="primaryContactNumber"
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Secondary Contact Number"
              v-model="secondaryContactNumber"
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Email Address"
              v-model="emailAddress"
              :rules="emailRules"
              required
            ></v-text-field>
          </v-flex>-->
          <v-flex md4>
            <v-text-field
              label="Other Contact details"
              v-model="otherContactDetails"
            ></v-text-field>
          </v-flex>
          <v-flex md4>
          <v-select
            label="Specialization"
            v-model="specialization"
            :items="specialtyList"
            item-value="value"
            item-text="label"
            :rules="[v => !!v || 'Specialization is required']"
            required
          ></v-select></v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12>
            <strong class="mb-3">PRC Registration</strong>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="PRC Number"
              v-model="prcNumber"
              :rules="prcNumberRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Date of Registration"
              type="date"
              v-model="prcRegistrationDate"
              :rules="prcRegistrationDateRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Valid Until"
              type="date"
              v-model="prcValidity"
              :rules="prcValidityRules"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
    
      <v-container
        class="pa-5"
      >
        <v-layout class="mb-5">
          
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 text-xs-right>
            <v-btn
              outline
              class="secondary secondary--text"
              to="/dashboard"
            >
              Back
            </v-btn>
            <v-btn
              @click="clear"
            >clear</v-btn>
            <v-btn
              @click="submit"
              color="primary"
              :disabled="!formValid"
            >
              Submit
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-snackbar
      bottom
      color="info"
      v-model="snackbar"
    >
      {{ text }}
      <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import axios from 'axios'
import PrivacyPolicy from '@/components/profile/privacyPolicy'
import { getUser } from '@/utils/token'
import config from '../../../configApi'
const apiUrl = config.apiUrl

export default {
  components: {
    PrivacyPolicy
  },
  computed: {
    user () {
      return getUser()
    }
  },
  beforeMount () {
    this.setInputValues()
  },
  data () {
    return {
      formValid: true,
      firstName: '',
      lastName: '',
      middleName: '',
      nickname: '',
      birthday: '',
      primaryContactNumber: '',
      secondaryContactNumber: '',
      emailAddress: '',
      password: '',
      otherContactDetails: '',
      prcNumber: '',
      prcRegistrationDate: '',
      prcValidity: '',
      agreePolicy: false,

      firstNameRules: [
        v => !!v || 'First Name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last Name is required'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required'
      ],
      prcNumberRules: [
        v => !!v || 'PRC Number is required'
      ],
      prcRegistrationDateRules: [
        v => !!v || 'This field is required'
      ],
      prcValidityRules: [
        v => !!v || 'This field is required'
      ],
      agreePolicyRules: [
        v => !!v || 'You must agree to continue! Please check details if all are correct.'
      ],
      specialization: '',
      specialtyList: [
        { label: 'Endocrinologist', value: 'Endocrinologist' },
        { label: 'Diabetologist', value: 'Diabetologist' },
        { label: 'Internist', value: 'Internist' },
        { label: 'Cardiologist', value: 'Cardiologist' },
        { label: 'General Physician', value: 'General Physician' },
        { label: 'Family Medicine', value: 'Family Medicine' },
        { label: 'Others', value: 'Others' }
      ],
      text: '',
      snackbar: false
    }
  },
  methods: {
    pickFile () {
      this.$refs.inputFile.click()
    },
    onFilePicked (e) {
      let file
      for (var x = 0, xlen = e.target.files.length; x < xlen; x++) {
        file = e.target.files[x]
        if (file.type.indexOf('image') !== -1) {
          var reader = new FileReader()

          reader.onload = e => {
            var img = new Image()
            img.src = e.target.result
            this.$refs.photo.src = img.src
          }

          reader.readAsDataURL(file)
        }
      }
    },
    submit (e) {
      // if (e.shiftKey === true) {
      // this.$router.push('/dashboard')
      // } else {
      this.submitForm()
      // }
    },
    submitForm () {
      if (this.$refs.form.validate()) {
        var data = {
          firstname: this.firstName,
          lastname: this.lastName,
          middlename: this.middleName,
          nickname: this.nickname,
          // birthdate: this.birthday,
          email: this.emailAddress,
          password: this.password,
          // phone_numbers: [
          //   {
          //     type: 'primary contact number',
          //     number: this.primaryContactNumber
          //   },
          //   {
          //     type: 'secondary contact number',
          //     number: this.secondaryContactNumber
          //   },
          //   {
          //     type: 'other contact number',
          //     number: this.otherContactDetails
          //   }
          // ],
          prc_number: this.prcNumber,
          registration_date: this.prcRegistrationDate,
          valid_until: this.prcValidity,
          specialty: this.specialization
        }
        var formData = new FormData()
        if (this.$refs.inputFile.files.length > 0) {
          formData.append('photo', this.$refs.inputFile.files[0])
        }
        for (var prop in data) {
          if (Array.isArray(data[prop])) {
            data[prop].map(obj => {
              formData.append(`${prop}[]`, JSON.stringify(obj))
            })
          } else {
            formData.set(`${prop}`, `${data[prop]}`)
          }
        }
        this.formValid = false
        // Native form submission is not yet supported
        axios.post(`${apiUrl}/profile/${this.user.id}`, formData).then(res => {
          this.text = 'Saved Successfully!'
          this.snackbar = true
          this.formValid = true
          this.setUserSession(res)
        }).catch(e => {
          this.text = e.response.data.message
          this.formValid = true
        })
      }
    },
    setUserSession (res) {
      localStorage.setItem('user', JSON.stringify(res.data))
      sessionStorage.setItem('user', JSON.stringify(res.data))
    },
    clear () {
      this.$refs.form.reset()
    },
    parseNumber () {
      for (let number of this.user.user_phone_numbers) {
        if (number.type === 'primary contact number') {
          this.primaryContactNumber = number.number
        }
        if (number.type === 'secondary contact number') {
          this.secondaryContactNumber = number.number
        }
        if (number.type === 'other contact number') {
          this.otherContactDetails = number.number
        }
      }
    },
    setInputValues () {
      this.lastName = this.user.lastname
      this.firstName = this.user.firstname
      this.middleName = this.user.middlename
      this.birthday = this.user.birthdate
      this.emailAddress = this.user.email
      this.prcNumber = this.user.user_license_numbers.prc_number
      this.prcRegistrationDate = this.user.user_license_numbers.registration_date
      this.prcValidity = this.user.user_license_numbers.valid_until
      this.specialization = this.user.specialty
      this.parseNumber()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/registration/index.vue